{
  "labels": {
    "paste": "Vložit",
    "pasteAsPlaintext": "Vložit jako prostý text",
    "pasteCharts": "Vložit grafy",
    "selectAll": "Vybrat vše",
    "multiSelect": "Přidat prvek do výběru",
    "moveCanvas": "Posunout plátno",
    "cut": "Vyjmout",
    "copy": "Kopírovat",
    "copyAsPng": "Zkopírovat do schránky jako PNG",
    "copyAsSvg": "Zkopírovat do schránky jako SVG",
    "copyText": "Zkopírovat do schránky jako text",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "Přenést blíž",
    "sendToBack": "Přenést do pozadí",
    "bringToFront": "Přenést do popředí",
    "sendBackward": "Přenést dál",
    "delete": "Smazat",
    "copyStyles": "Kopírovat styly",
    "pasteStyles": "Vložit styly",
    "stroke": "Obrys",
    "background": "Pozadí",
    "fill": "Výplň",
    "strokeWidth": "Tloušťka tahu",
    "strokeStyle": "Styl tahu",
    "strokeStyle_solid": "Plný",
    "strokeStyle_dashed": "Čárkovaný",
    "strokeStyle_dotted": "Tečkovaný",
    "sloppiness": "Stylizace",
    "opacity": "Průhlednost",
    "textAlign": "Zarovnání textu",
    "edges": "Hrany",
    "sharp": "Ostré",
    "round": "Zaoblené",
    "arrowheads": "Styl šipky",
    "arrowhead_none": "Žádný",
    "arrowhead_arrow": "Šipka",
    "arrowhead_bar": "Kóta",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Trojúhelník",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "Velikost písma",
    "fontFamily": "Písmo",
    "addWatermark": "Přidat \"Vyrobeno s Excalidraw\"",
    "handDrawn": "Od ruky",
    "normal": "Normální",
    "code": "Kód",
    "small": "Malé",
    "medium": "Střední",
    "large": "Velké",
    "veryLarge": "Velmi velké",
    "solid": "Plný",
    "hachure": "Hachure",
    "zigzag": "Klikatě",
    "crossHatch": "Křížový šrafování",
    "thin": "Tenký",
    "bold": "Tlustý",
    "left": "Vlevo",
    "center": "Na střed",
    "right": "Vpravo",
    "extraBold": "Extra tlustý",
    "architect": "Architekt",
    "artist": "Umělec",
    "cartoonist": "Kartoonista",
    "fileTitle": "Název souboru",
    "colorPicker": "Výběr barvy",
    "canvasColors": "Použito na plátně",
    "canvasBackground": "Pozadí plátna",
    "drawingCanvas": "Kreslicí plátno",
    "layers": "Vrstvy",
    "actions": "Akce",
    "language": "Jazyk",
    "liveCollaboration": "Živá spolupráce...",
    "duplicateSelection": "Duplikovat",
    "untitled": "Bez názvu",
    "name": "Název",
    "yourName": "Vaše jméno",
    "madeWithExcalidraw": "Vytvořeno v Excalidraw",
    "group": "Sloučit výběr do skupiny",
    "ungroup": "Zrušit sloučení skupiny",
    "collaborators": "Spolupracovníci",
    "showGrid": "Zobrazit mřížku",
    "addToLibrary": "Přidat do knihovny",
    "removeFromLibrary": "Odebrat z knihovny",
    "libraryLoadingMessage": "Načítání knihovny…",
    "libraries": "Procházet knihovny",
    "loadingScene": "Načítání scény…",
    "align": "Zarovnání",
    "alignTop": "Zarovnat nahoru",
    "alignBottom": "Zarovnat dolů",
    "alignLeft": "Zarovnat vlevo",
    "alignRight": "Zarovnejte vpravo",
    "centerVertically": "Vycentrovat svisle",
    "centerHorizontally": "Vycentrovat vodorovně",
    "distributeHorizontally": "Rozložit horizontálně",
    "distributeVertically": "Rozložit svisle",
    "flipHorizontal": "Převrátit vodorovně",
    "flipVertical": "Převrátit svisle",
    "viewMode": "Náhled",
    "share": "Sdílet",
    "showStroke": "Zobrazit výběr barvy",
    "showBackground": "Zobrazit výběr barev pozadí",
    "toggleTheme": "Přepnout tmavý řežim",
    "personalLib": "Osobní knihovna",
    "excalidrawLib": "Exkalidraw knihovna",
    "decreaseFontSize": "Zmenšit písmo",
    "increaseFontSize": "Zvětšit písmo",
    "unbindText": "Zrušit vazbu textu",
    "bindText": "Vázat text s kontejnerem",
    "createContainerFromText": "Zabalit text do kontejneru",
    "link": {
      "edit": "Upravit odkaz",
      "editEmbed": "",
      "create": "Vytvořit odkaz",
      "createEmbed": "",
      "label": "Odkaz",
      "labelEmbed": "",
      "empty": ""
    },
    "lineEditor": {
      "edit": "Upravit čáru",
      "exit": "Ukončit editor řádků"
    },
    "elementLock": {
      "lock": "Uzamknout",
      "unlock": "Odemknout",
      "lockAll": "Uzamknout vše",
      "unlockAll": "Odemknout vše"
    },
    "statusPublished": "Zveřejněno",
    "sidebarLock": "Ponechat postranní panel otevřený",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "Vyberte barvu z plátna",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "Dosud neexistují žádné položky...",
    "hint_emptyLibrary": "Vyberte položku na plátně a přidejte ji sem nebo nainstalujte knihovnu z veřejného úložiště níže.",
    "hint_emptyPrivateLibrary": "Vyberte položku na plátně a přidejte ji sem."
  },
  "buttons": {
    "clearReset": "Resetovat plátno",
    "exportJSON": "Exportovat do souboru",
    "exportImage": "Exportovat obrázek...",
    "export": "Uložit jako...",
    "copyToClipboard": "Kopírovat do schránky",
    "save": "Uložit do aktuálního souboru",
    "saveAs": "Uložit jako",
    "load": "Otevřít",
    "getShareableLink": "Získat odkaz pro sdílení",
    "close": "Zavřít",
    "selectLanguage": "Zvolit jazyk",
    "scrollBackToContent": "Přejít zpět na obsah",
    "zoomIn": "Přiblížit",
    "zoomOut": "Oddálit",
    "resetZoom": "Resetovat přiblížení",
    "menu": "Menu",
    "done": "Hotovo",
    "edit": "Upravit",
    "undo": "Zpět",
    "redo": "Znovu",
    "resetLibrary": "Obnovit knihovnu",
    "createNewRoom": "Vytvořit novou místnost",
    "fullScreen": "Celá obrazovka",
    "darkMode": "Tmavý režim",
    "lightMode": "Světlý režim",
    "zenMode": "Zen mód",
    "objectsSnapMode": "",
    "exitZenMode": "Opustit zen mód",
    "cancel": "Zrušit",
    "clear": "Vyčistit",
    "remove": "Odstranit",
    "embed": "",
    "publishLibrary": "Zveřejnit",
    "submit": "Odeslat",
    "confirm": "Potvrdit",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "Toto vymaže celé plátno. Jste si jisti?",
    "couldNotCreateShareableLink": "Nepodařilo se vytvořit sdílitelný odkaz.",
    "couldNotCreateShareableLinkTooBig": "Nepodařilo se vytvořit sdílený odkaz: scéna je příliš velká",
    "couldNotLoadInvalidFile": "Nepodařilo se načíst neplatný soubor",
    "importBackendFailed": "Import z backendu se nezdařil.",
    "cannotExportEmptyCanvas": "Nelze exportovat prázdné plátno.",
    "couldNotCopyToClipboard": "Nelze zkopírovat do schránky.",
    "decryptFailed": "Nelze dešifrovat data.",
    "uploadedSecurly": "Nahrávání je zabezpečeno koncovým šifrováním, což znamená, že server Excalidraw ani třetí strany nemohou obsah přečíst.",
    "loadSceneOverridePrompt": "Načítání externího výkresu nahradí váš existující obsah. Přejete si pokračovat?",
    "collabStopOverridePrompt": "Zastavení relace přepíše vaše předchozí, lokálně uložené kresby. Jste si jisti?\n\n(Pokud chcete zachovat místní kresbu, jednoduše zavřete kartu prohlížeče)",
    "errorAddingToLibrary": "Položku nelze přidat do knihovny",
    "errorRemovingFromLibrary": "Položku nelze odstranit z knihovny",
    "confirmAddLibrary": "Tímto přidáte {{numShapes}} tvarů do tvé knihovny. Jste si jisti?",
    "imageDoesNotContainScene": "Zdá se, že tento obrázek neobsahuje žádná data o scéně. Zapnuli jste při exportu vkládání scény?",
    "cannotRestoreFromImage": "Scénu nelze obnovit z tohoto souboru obrázku",
    "invalidSceneUrl": "Nelze importovat scénu z zadané URL. Je buď poškozená, nebo neobsahuje platná JSON data Excalidraw.",
    "resetLibrary": "Tímto vymažete vaši knihovnu. Jste si jisti?",
    "removeItemsFromsLibrary": "Smazat {{count}} položek z knihovny?",
    "invalidEncryptionKey": "Šifrovací klíč musí mít 22 znaků. Live spolupráce je zakázána.",
    "collabOfflineWarning": "Není k dispozici žádné internetové připojení.\nVaše změny nebudou uloženy!"
  },
  "errors": {
    "unsupportedFileType": "Nepodporovaný typ souboru.",
    "imageInsertError": "Nelze vložit obrázek. Zkuste to později...",
    "fileTooBig": "Soubor je příliš velký. Maximální povolená velikost je {{maxSize}}.",
    "svgImageInsertError": "Nelze vložit SVG obrázek. Značení SVG je neplatné.",
    "failedToFetchImage": "",
    "invalidSVGString": "Neplatný SVG.",
    "cannotResolveCollabServer": "Nelze se připojit ke sdílenému serveru. Prosím obnovte stránku a zkuste to znovu.",
    "importLibraryError": "Nelze načíst knihovnu",
    "collabSaveFailed": "Nelze uložit do databáze na serveru. Pokud problémy přetrvávají, měli byste uložit soubor lokálně, abyste se ujistili, že neztratíte svou práci.",
    "collabSaveFailed_sizeExceeded": "Nelze uložit do databáze na serveru, plátno se zdá být příliš velké. Měli byste uložit soubor lokálně, abyste se ujistili, že neztratíte svou práci.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "Vypadá to, že používáte Brave prohlížeč s povoleným nastavením <bold>Aggressively Block Fingerprinting</bold>.",
      "line2": "To by mohlo vést k narušení <bold>Textových elementů</bold> ve vašich výkresech.",
      "line3": "Důrazně doporučujeme zakázat toto nastavení. Můžete sledovat <link>tyto kroky</link> jak to udělat.",
      "line4": "Pokud vypnutí tohoto nastavení neopravuje zobrazení textových prvků, prosím, otevřete <issueLink>problém</issueLink> na našem GitHubu, nebo nám napište na <discordLink>Discord</discordLink>"
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Výběr",
    "image": "Vložit obrázek",
    "rectangle": "Obdélník",
    "diamond": "Diamant",
    "ellipse": "Elipsa",
    "arrow": "Šipka",
    "line": "Čára",
    "freedraw": "Kreslení",
    "text": "Text",
    "library": "Knihovna",
    "lock": "Po kreslení ponechat vybraný nástroj aktivní",
    "penMode": "Režim Pera - zabránit dotyku",
    "link": "Přidat/aktualizovat odkaz pro vybraný tvar",
    "eraser": "Guma",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "Ruka (nástroj pro posouvání)",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "Akce plátna",
    "selectedShapeActions": "Akce vybraného tvaru",
    "shapes": "Tvary"
  },
  "hints": {
    "canvasPanning": "Chcete-li přesunout plátno, podržte kolečko nebo mezerník při tažení nebo použijte nástroj Ruka",
    "linearElement": "Kliknutím pro více bodů, táhnutím pro jednu čáru",
    "freeDraw": "Klikněte a táhněte, pro ukončení pusťte",
    "text": "Tip: Text můžete také přidat dvojitým kliknutím kdekoli pomocí nástroje pro výběr",
    "embeddable": "",
    "text_selected": "Dvojklikem nebo stisknutím klávesy ENTER upravíte text",
    "text_editing": "Stiskněte Escape nebo Ctrl/Cmd+ENTER pro dokončení úprav",
    "linearElementMulti": "Klikněte na poslední bod nebo stiskněte Escape anebo Enter pro dokončení",
    "lockAngle": "Úhel můžete omezit podržením SHIFT",
    "resize": "Můžete omezit proporce podržením SHIFT při změně velikosti,\npodržte ALT pro změnu velikosti od středu",
    "resizeImage": "Můžete volně změnit velikost podržením SHIFT,\npodržením klávesy ALT změníte velikosti od středu",
    "rotate": "Úhly můžete omezit podržením SHIFT při otáčení",
    "lineEditor_info": "Podržte Ctrl/Cmd a dvakrát klikněte nebo stiskněte Ctrl/Cmd + Enter pro úpravu bodů",
    "lineEditor_pointSelected": "Stisknutím tlačítka Delete odstraňte bod(y),\nCtrl/Cmd+D pro duplicitu nebo táhnutím pro přesun",
    "lineEditor_nothingSelected": "Vyberte bod, který chcete upravit (podržením klávesy SHIFT vyberete více položek),\nnebo podržením klávesy Alt a kliknutím přidáte nové body",
    "placeImage": "Kliknutím umístěte obrázek, nebo klepnutím a přetažením ručně nastavíte jeho velikost",
    "publishLibrary": "Publikovat vlastní knihovnu",
    "bindTextToElement": "Stiskněte Enter pro přidání textu",
    "deepBoxSelect": "Podržte Ctrl/Cmd pro hluboký výběr a pro zabránění táhnutí",
    "eraserRevert": "Podržením klávesy Alt vrátíte prvky označené pro smazání",
    "firefox_clipboard_write": "Tato funkce může být povolena nastavením vlajky \"dom.events.asyncClipboard.clipboardItem\" na \"true\". Chcete-li změnit vlajky prohlížeče ve Firefoxu, navštivte stránku \"about:config\".",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "Náhled nelze zobrazit",
    "canvasTooBig": "Plátno je možná příliš velké.",
    "canvasTooBigTip": "Tip: zkus posunout nejvzdálenější prvky trochu blíže k sobě."
  },
  "errorSplash": {
    "headingMain": "Chyba. Zkuste <button>znovu načíst stránku</button>.",
    "clearCanvasMessage": "Pokud opětovné načtení nefunguje, zkuste <button>vymazat plátno</button>.",
    "clearCanvasCaveat": " To povede ke ztrátě dat ",
    "trackedToSentry": "Chyba identifikátoru {{eventId}} byl zaznamenán v našem systému.",
    "openIssueMessage": "Byli jsme velmi opatrní, abychom neuváděli informace o Vaší scéně. Pokud vaše scéna není soukromá, zvažte prosím sledování na našem <button>bug trackeru</button>. Uveďte prosím níže uvedené informace kopírováním a vložením do problému na GitHubu.",
    "sceneContent": "Obsah scény:"
  },
  "roomDialog": {
    "desc_intro": "Můžete pozvat lidi na vaši aktuální scénu ke spolupráci s vámi.",
    "desc_privacy": "Nebojte se, relace používá end-to-end šifrování, takže cokoliv nakreslíte zůstane soukromé. Ani náš server nebude schopen vidět, s čím budete pracovat.",
    "button_startSession": "Zahájit relaci",
    "button_stopSession": "Ukončit relaci",
    "desc_inProgressIntro": "Živá spolupráce právě probíhá.",
    "desc_shareLink": "Sdílejte tento odkaz s každým, s kým chcete spolupracovat:",
    "desc_exitSession": "Zastavením relace se odpojíte od místnosti, ale budete moci pokračovat v práci s touto scénou lokálně. Všimněte si, že to nebude mít vliv na ostatní lidi a budou stále moci spolupracovat na jejich verzi.",
    "shareTitle": "Připojte se k aktivní spolupráci na Excalidraw"
  },
  "errorDialog": {
    "title": "Chyba"
  },
  "exportDialog": {
    "disk_title": "Uložit na disk",
    "disk_details": "Exportovat data scény do souboru, ze kterého můžete importovat později.",
    "disk_button": "Uložit do souboru",
    "link_title": "Odkaz pro sdílení",
    "link_details": "Exportovat jako odkaz pouze pro čtení.",
    "link_button": "Exportovat do odkazu",
    "excalidrawplus_description": "Uložit scénu do vašeho pracovního prostoru Excalidraw+.",
    "excalidrawplus_button": "Exportovat",
    "excalidrawplus_exportError": "Export do Excalidraw+ se v tuto chvíli nezdařil..."
  },
  "helpDialog": {
    "blog": "Přečtěte si náš blog",
    "click": "kliknutí",
    "deepSelect": "Hluboký výběr",
    "deepBoxSelect": "Hluboký výběr uvnitř boxu a zabránění táhnnutí",
    "curvedArrow": "Zakřivená šipka",
    "curvedLine": "Zakřivená čára",
    "documentation": "Dokumentace",
    "doubleClick": "dvojklik",
    "drag": "tažení",
    "editor": "Editor",
    "editLineArrowPoints": "Upravit body linií/šipek",
    "editText": "Upravit text / přidat popis",
    "github": "Našel jsi problém? Nahlaš ho",
    "howto": "Sledujte naše návody",
    "or": "nebo",
    "preventBinding": "Zabránit vázání šipky",
    "tools": "Nástroje",
    "shortcuts": "Klávesové zkratky",
    "textFinish": "Dokončit úpravy (textový editor)",
    "textNewLine": "Přidat nový řádek (textový editor)",
    "title": "Nápověda",
    "view": "Zobrazení",
    "zoomToFit": "Přiblížit na zobrazení všech prvků",
    "zoomToSelection": "Přiblížit na výběr",
    "toggleElementLock": "Zamknout/odemknout výběr",
    "movePageUpDown": "Posunout stránku nahoru/dolů",
    "movePageLeftRight": "Přesunout stránku doleva/doprava"
  },
  "clearCanvasDialog": {
    "title": "Vymazat plátno"
  },
  "publishDialog": {
    "title": "Publikovat knihovnu",
    "itemName": "Název položky",
    "authorName": "Jméno autora",
    "githubUsername": "GitHub uživatelské jméno",
    "twitterUsername": "Twitter uživatelské jméno",
    "libraryName": "Název knihovny",
    "libraryDesc": "Popis knihovny",
    "website": "Webová stránka",
    "placeholder": {
      "authorName": "Jméno nebo uživatelské jméno",
      "libraryName": "Název vaší knihovny",
      "libraryDesc": "Popis Vaší knihovny, který pomůže lidem pochopit její využití",
      "githubHandle": "Github uživatelské jméno (nepovinné), abyste mohli upravovat knihovnu poté co je odeslána ke kontrole",
      "twitterHandle": "Twitter uživatelské jméno (nepovinné), abychom věděli koho označit při propagaci na Twitteru",
      "website": "Odkaz na Vaši osobní webovou stránku nebo jinam (nepovinné)"
    },
    "errors": {
      "required": "Povinné",
      "website": "Zadejte platnou URL adresu"
    },
    "noteDescription": "Odešlete svou knihovnu, pro zařazení do <link>veřejného úložiště knihoven</link>, odkud ji budou moci při kreslení využít i ostatní uživatelé.",
    "noteGuidelines": "Knihovna musí být nejdříve ručně schválena. Přečtěte si prosím <link>pokyny</link>",
    "noteLicense": "Odesláním souhlasíte s tím, že knihovna bude zveřejněna pod <link>MIT licencí</link>, stručně řečeno, kdokoli ji může používat bez omezení.",
    "noteItems": "Každá položka knihovny musí mít svůj vlastní název, aby byla filtrovatelná. Následující položky knihovny budou zahrnuty:",
    "atleastOneLibItem": "Vyberte alespoň jednu položku knihovny, kterou chcete začít",
    "republishWarning": "Poznámka: některé z vybraných položek jsou označeny jako již zveřejněné/odeslané. Položky byste měli znovu odeslat pouze při aktualizaci existující knihovny nebo podání."
  },
  "publishSuccessDialog": {
    "title": "Knihovna byla odeslána",
    "content": "Děkujeme vám {{authorName}}. Vaše knihovna byla odeslána k posouzení. Stav můžete sledovat <link>zde</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Resetovat knihovnu",
    "removeItemsFromLib": "Odstranit vybrané položky z knihovny"
  },
  "imageExportDialog": {
    "header": "Exportovat obrázek",
    "label": {
      "withBackground": "Pozadí",
      "onlySelected": "Pouze vybrané",
      "darkMode": "Tmavý režim",
      "embedScene": "Vložit scénu",
      "scale": "Měřítko",
      "padding": "Odsazení"
    },
    "tooltip": {
      "embedScene": "Data scény budou uložena do exportovaného souboru PNG/SVG tak, aby z něj mohla být scéna obnovena.\nZvýší se velikost exportovaného souboru."
    },
    "title": {
      "exportToPng": "Exportovat do PNG",
      "exportToSvg": "Exportovat do SVG",
      "copyPngToClipboard": "Kopírovat PNG do schránky"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Kopírovat do schránky"
    }
  },
  "encrypted": {
    "tooltip": "Vaše kresby jsou end-to-end šifrované, takže servery Excalidraw je nikdy neuvidí.",
    "link": "Blog příspěvek na end-to-end šifrování v Excalidraw"
  },
  "stats": {
    "angle": "Úhel",
    "element": "Prvek",
    "elements": "Prvky",
    "height": "Výška",
    "scene": "Scéna",
    "selected": "Vybráno",
    "storage": "Úložiště",
    "title": "Statistika pro nerdy",
    "total": "Celkem",
    "version": "Verze",
    "versionCopy": "Kliknutím zkopírujete",
    "versionNotAvailable": "Verze není k dispozici",
    "width": "Šířka"
  },
  "toast": {
    "addedToLibrary": "Přidáno do knihovny",
    "copyStyles": "Styly byly zkopírovány.",
    "copyToClipboard": "Zkopírováno do schránky.",
    "copyToClipboardAsPng": "{{exportSelection}} zkopírován do schránky jako PNG\n({{exportColorScheme}})",
    "fileSaved": "Soubor byl uložen.",
    "fileSavedToFilename": "Uloženo do {filename}",
    "canvas": "plátno",
    "selection": "výběr",
    "pasteAsSingleElement": "Pomocí {{shortcut}} vložte jako jeden prvek,\nnebo vložte do existujícího textového editoru",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "Průhledná",
    "black": "Černá",
    "white": "Bílá",
    "red": "Červená",
    "pink": "Růžová",
    "grape": "Vínová",
    "violet": "Fialová",
    "gray": "Šedá",
    "blue": "Modrá",
    "cyan": "Azurová",
    "teal": "Modrozelená",
    "green": "Zelená",
    "yellow": "Žlutá",
    "orange": "Oranžová",
    "bronze": "Bronzová"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Všechna vaše data jsou uložena lokálně ve vašem prohlížeči.",
      "center_heading_plus": "Chcete místo toho přejít na Excalidraw+?",
      "menuHint": "Export, nastavení, jazyky, ..."
    },
    "defaults": {
      "menuHint": "Export, nastavení a další...",
      "center_heading": "Diagramy. Vytvořeny. Jednoduše.",
      "toolbarHint": "Vyberte nástroj a začněte kreslit!",
      "helpHint": "Zkratky a pomoc"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "Nejpoužívanější vlastní barvy",
    "colors": "Barvy",
    "shades": "Stíny",
    "hexCode": "Hex kód",
    "noShades": "Pro tuto barvu nejsou k dispozici žádné odstíny"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
